import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Container, Row, Col } from "react-bootstrap";
import InputWrapper from "@egovernments/digit-ui-module-obps/src/pages/citizen/AVPForms/layout/inputWrapper";
import ButtonWrapper from "../citizen/TCPForms/components/Button";
import { OBPSService } from "../../../../../libraries/src/services/elements/OBPS";
import { useHistory } from "react-router-dom";
import { citizenBaseUrl } from "@egovernments/digit-ui-module-obps/src/pages/citizen/AVPForms/components/data";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@material-ui/core";
const DuePayment = ({ setShowDuePaymentGroup }) => {
  const {
    handleSubmit,
    control,
    getValues,
    register,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: "",
    },
  });

  const [tableData, setTableData] = useState([]);
  const [tableMeta, setTableMeta] = useState({ applicationNo: "" });
  const [loading, setLoading] = useState(false);
  const stateId = Digit.ULBService.getStateId();
  const history = useHistory();

  const handleApplicationSearch = async (applicationNo) => {
    console.log("inside handleApplicationSearch with app no:", applicationNo);
    let response;
    if (!applicationNo) {
      console.warn("No application number provided");
      return;
    }
    setLoading(true);
    setTableData([]);
    setTableMeta({ applicationNo: "" });
    try {
      if (applicationNo) {
        console.log("insideIf", applicationNo, stateId);

        response = await OBPSService.BPASearchNoAuth(stateId, { applicationNo });
        const taxHeadEstimates = response?.[0]?.taxHeadEstimates || [];
        const appNo = response?.[0]?.applicationNo || "-";
        setTableMeta({ applicationNo: appNo });
        console.log("response", response);

        const consumerCode = appNo;
        // Create an array of promises
        const billPromises = taxHeadEstimates.map((item) => {
          const businessService = item.calculationBusinesserviceId;
          return Digit.PaymentService.fetchBillNoAuth(stateId, { consumerCode, businessService }).then((res) => res.Bill[0]);
        });

        // Run them in parallel and wait for all to settle
        const results = await Promise.all(billPromises);
        console.log("results", results);

        // Prepare table data
        const tableRows = taxHeadEstimates.map((item) => {
          const challanNumber = item.challanNo || "-";
          const paymentStatus = item.paymentStatus || "-";
          const amount = item.estimateAmount || 0;
          const date = item.challanGeneratedDateTime
            ? (() => {
                const [datePart] = item.challanGeneratedDateTime.split(" ");
                const [yyyy, mm, dd] = datePart.split("-");
                return `${dd}-${mm}-${yyyy}`;
              })()
            : "N/A";
          let businessService = item.calculationBusinesserviceId;
          return {
            applicationNo: appNo,
            challanNumber,
            amount,
            date,
            businessService,
            paymentStatus,
          };
        });
        console.log("tableRows", tableRows);

        setTableData(tableRows);
      }
    } catch (e) {
      setTableData([]);
    } finally {
      setLoading(false);
    }
  };

  const onSubmit = (data) => {
    alert(`Submitted: ${JSON.stringify(data)}`);
  };

  return (
    <section className="groupContainer2">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="formContainer">
          <div className="formHeaderContainer mb-3">
            <h4 className="formHeading common-header-sec text-black">
              Pay due payments{" "}
              <IconButton aria-label="close" onClick={() => setShowDuePaymentGroup(false)} style={{ color: "red", padding: "0", float: "right" }}>
                <CloseIcon />
              </IconButton>
            </h4>
          </div>
          <Container fluid className="formInputContainer common-app-form">
            <Row>
              <Col>
                <InputWrapper
                  label={"Application Number"}
                  control={control}
                  placeholder={"Enter application number"}
                  name="applicationNo"
                  mandatory
                  width={"20.25vw"}
                  maxLength={23}
                  type="textInput"
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  showSearchIcon={true}
                  onSearchClick={() => handleApplicationSearch(getValues("applicationNo"))}
                />
              </Col>
              <Col></Col>
            </Row>
          </Container>
        </div>
        {/* Table Section */}
        <div className="table-container" style={{ margin: "24px 0" }}>
          {loading ? (
            <div style={{ textAlign: "center", padding: "16px" }}>Loading...</div>
          ) : tableData.length > 0 ? (
            <React.Fragment>
              <caption className="emp-table-caption">Due Payments</caption>
              <table className="application-table" style={{ width: "100%" }}>
                <thead>
                  <tr>
                    <th>Sr No.</th>
                    <th>Application Number</th>
                    <th>Challan Number</th>
                    <th>Amount</th>
                    <th>Date</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {tableData.map((row, idx) => (
                    <tr key={idx}>
                      <td>{idx + 1}</td>
                      <td>{row.applicationNo}</td>
                      <td>{row.challanNumber}</td>
                      <td>₹ {row.amount}</td>
                      <td>{row.date}</td>
                      <td>
                        {row?.paymentStatus === "PAID" ? (
                          "PAID"
                        ) : (
                          <button
                            className="btn btn-primary"
                            style={{ padding: "5px", backgroundColor: "#1F4A7C" }}
                            onClick={() => {
                              const redirectUrl = `${citizenBaseUrl}/payment/collect/noAuth/${row.businessService}/${row.applicationNo}/${stateId}/tenantId=${stateId}`;
                              history.push(redirectUrl);
                            }}
                          >
                            Pay Now
                          </button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </React.Fragment>
          ) : null}
        </div>
        {/* <div className="footerContainer">
          <div className="buttonWrapper">
            <ButtonWrapper variant="contained" color="success" size="medium" label="Save" type="submit" sx={{ backgroundColor: "#157CB3" }} />
          </div>
        </div> */}
      </form>
    </section>
  );
};

export default DuePayment;
